<footer class="commercial-footer">
  <div class="sectpad container section footpad">
    <div class="p-3 pt-5 col-sm-12 row m-0">
      <div class="col-sm-6 col-md-3 col-lg-2 col-6 pl-0">
        <h5>Company</h5>
        <ul class="list-unstyled text-small">
          <!-- <li><a class="text-muted" href="#/commercial" [ngx-scroll-to]="'#shopSection'">About</a></li> -->
          <li>
            <a
              class="text-muted"
              routerLink="/get-started"
              href="javascript:void(0)"
              >Residential</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              routerLink="/commercial/get-started"
              href="javascript:void(0)"
              >Commercial</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              routerLink="/giveback"
              href="javascript:void(0)"
              >Giveback</a
            >
          </li>
        </ul>
      </div>
      <div class="col-sm-6 col-md-3 col-lg-4 col-6 pl-0 webview">
        <h5>Support & Learn</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a class="text-muted" routerLink="/faq" href="javascript:void(0)"
              >FAQ</a
            >
          </li>
          <li>
            <a class="text-muted" routerLink="/blog" href="javascript:void(0)"
              >Blog</a
            >
          </li>
          <!-- <li><a class="text-muted" href="javascript:void(0)" data-toggle="modal" data-target="#contactModal">Contact Us</a></li> -->
          <!-- <li><a class="text-muted" href="javascript:void(0)" data-toggle="modal" data-target="#contactModal" (click)="showModal()">Contact Us</a></li> -->
          <li>
            <a
              class="text-muted"
              routerLink="/faq/contact-us"
              href="javascript:void(0)"
              >Contact Us</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              routerLink="/faq/privacy-policy"
              href="javascript:void(0)"
              >Privacy Policy</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              routerLink="/faq/terms-of-service"
              href="javascript:void(0)"
              >Terms of Service</a
            >
          </li>
        </ul>
      </div>
      <div class="col-sm-6 col-md-3 col-lg-2 col-6 pl-0 mobileview">
        <h5>Support & Learn</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a class="text-muted" routerLink="/faq" href="javascript:void(0)"
              >FAQ</a
            >
          </li>
          <li>
            <a class="text-muted" routerLink="/blog" href="javascript:void(0)"
              >Blog</a
            >
          </li>
          <!-- <li><a class="text-muted" href="javascript:void(0)" data-toggle="modal" data-target="#contactModal">Contact Us</a></li> -->
          <!-- <li><a class="text-muted" href="javascript:void(0)" data-toggle="modal" data-target="#contactModal" (click)="showModal()">Contact Us</a></li> -->
          <li>
            <a
              class="text-muted"
              routerLink="/faq/contact-us"
              href="javascript:void(0)"
              >Contact Us</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              routerLink="/faq/privacy-policy"
              href="javascript:void(0)"
              >Privacy Policy</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              routerLink="/faq/terms-of-service"
              href="javascript:void(0)"
              >Terms of Service</a
            >
          </li>
        </ul>
      </div>
      <!-- <div class="col-sm-6 col-md-3 col-lg-2 col-6 pl-0">
        <h5>Account</h5>
        <ul class="list-unstyled text-small">
          <li><a class="text-muted" href="javascript:void(0)" routerLink="/login">Login</a></li>
        </ul>
      </div> -->
      <div
        class="col-sm-6 col-md-3 col-lg-4 offset-lg-2 col-6 pl-0 webview text-right"
      >
        <div class="ourcommunity">
          <h5>Join Our Community</h5>
          <div class="col-sm-12 p-0 pt-1 text-right">
            <div class="float-right d-flex">
              <a
                href="https://www.facebook.com/honestgorilla1/"
                target="_blank"
              >
                <img
                  class="mt-1 mr-3 float-left webview"
                  src="assets/images/fb2.png"
                  alt=""
                  width="11"
              /></a>
              <a href="https://twitter.com/honestgorilla" target="_blank">
                <img
                  class="mb-2 mr-3 mt-1 float-left webview"
                  src="assets/images/twitter2.png"
                  alt=""
                  width="22"
              /></a>
              <a
                href="https://www.instagram.com/honestgorilla_energy/ "
                target="_blank"
              >
                <img
                  class="mb-2 mr-3 mt-1 float-left webview"
                  src="assets/images/instgram2.png"
                  alt=""
                  width="21"
              /></a>
              <a
                href=" https://www.facebook.com/honestgorilla1/"
                target="_blank"
              >
                <img
                  class="pt-1 mb-2 mr-3 float-left mobileview"
                  src="assets/images/mbl_footer_fb.svg"
                  alt=""
                  width="22"
              /></a>
              <a href="https://twitter.com/honestgorilla" target="_blank">
                <img
                  class="pt-2px mb-2 mr-3 mt-1 float-left mobileview"
                  src="assets/images/mbl_footer_twitter.svg"
                  alt=""
                  width="22"
              /></a>
              <a
                href="https://www.instagram.com/honestgorilla_energy/ "
                target="_blank"
              >
                <img
                  class="mb-2 mr-3 mt-1 float-left mobileview"
                  src="assets/images/mbl_footer_ insta.svg"
                  alt=""
                  width="22"
              /></a>
            </div>
          </div>
          <small
            class="d-block mb-3 mt-3 w-100 float-left fs18 cpyright text-right"
            >&copy; {{ licenseHG }}<br />
            TX PUC Broker License #: BR220098.</small
          >
          <small
            class="d-block mb-3 mt-3 w-100 float-left"
            style="font-size: 12px; color: #e2e2e2 !important"
            >Version: 1.16</small
          >
        </div>
      </div>
      <div class="row">
        <div class="col-6"></div>
        <div
          class="col-sm-6 col-6 row justify-content-end pull-right mobileview"
        >
          <div class="pull-right">
            <h5>Join Our Community</h5>
            <div class="col-sm-12 p-0 pt-1 d-flex">
              <a
                href=" https://www.facebook.com/honestgorilla1/"
                target="_blank"
              >
                <img
                  class="pt-1 mb-2 mr-3 mobileview"
                  src="assets/images/mbl_footer_fb.svg"
                  alt=""
                  width="22"
              /></a>
              <a href="https://twitter.com/honestgorilla" target="_blank">
                <img
                  class="pt-2px mb-2 mr-3 mt-1 mobileview"
                  src="assets/images/mbl_footer_twitter.svg"
                  alt=""
                  width="22"
              /></a>
              <a
                href="https://www.instagram.com/honestgorilla_energy/ "
                target="_blank"
              >
                <img
                  class="mb-2 mr-3 mt-1 mobileview"
                  src="assets/images/mbl_footer_ insta.svg"
                  alt=""
                  width="22"
              /></a>
            </div>
            <small class="d-block mb-3 mt-3 w-100 fs18 cpyright"
              >&copy; {{ licenseHG }}<br />
              TX PUC Broker License #: BR220098.</small
            >
            <small
              class="d-block mb-3 mt-3 w-100 float-left"
              style="font-size: 12px; color: #e2e2e2 !important"
              >Version: 1.16</small
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
